"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var empty_statistics_png_1 = __importDefault(require("@assets/Statistics/empty_statistics.png"));
var react_i18next_1 = require("react-i18next");
function NoData(_a) {
    var angularJsDependencies = _a.angularJsDependencies;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "no-data" },
        react_1.default.createElement("img", { src: empty_statistics_png_1.default }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("h2", null, t('COMMON.NO_DATA.TITLE')),
            react_1.default.createElement("p", null, t('COMMON.NO_DATA.BODY')),
            react_1.default.createElement("div", { className: "links-container" },
                react_1.default.createElement("a", { href: "https://help.besedo.com/17022-getting-started/how-to-import-data", rel: "noreferrer", target: "_blank" }, t('COMMON.NO_DATA.KNOWLEDGE_BASE_LINK')),
                react_1.default.createElement("a", { href: angularJsDependencies.href('app.assignment.csvImporter.step0') },
                    " ",
                    t('COMMON.NO_DATA.CSV_IMPORTER_LINK'))))));
}
exports.default = NoData;
